import { useCallback, useState } from 'react';
import api from '../../api/api';
import { useUserContext } from '../../context/UserContext';
import biometrics from '../../biometrics/biometrics';
import { clearAllFormDrafts } from '../../dynamic-forms/drafts/formDraftStore';
import { Platform } from 'react-native';
// import { cancelAllNotifications } from '../../screens/study/helpers/ParticipantEventLocalNotificationHelper';

export function useLogout() {
  const { clearUserSession } = useUserContext();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const logout = useCallback(async () => {
    // await cancelAllNotifications();
    setIsLoggedOut(false);
    setIsLoggingOut(true);
    const enabled =
      Platform.OS === 'web' ? null : await biometrics.getBiometricLogin();
    if (enabled) {
      const accessToken = await api.getAccessToken();
      if (accessToken) {
        await biometrics.setBiometricAccessToken(accessToken);
      }
    }
    await api.removeAccessToken();
    // drafts contain the participant's form answers — never leave them
    // behind for the next account on this device (CD-222)
    await clearAllFormDrafts();
    clearUserSession();
    setIsLoggingOut(false);
    setIsLoggedOut(true);
  }, [clearUserSession]);
  return { logout, isLoggingOut, isLoggedOut };
}
